const loadGoogleMapsApi = require('load-google-maps-api');

let GMapsReady = false;

class Maps {
	constructor(el, options) {
		this.el = el;
		this.init();
	}

	/**
	 * get data attribute and return object
	 *
	 * @param {Object} el (Optional)
	 * @returns {JSON} Object
	 */
	getData(el) {
		const element = typeof el !== "undefined" ? el : this.el;
		return JSON.parse(element.dataset.maps);
	}

	/**
	 * initialize google maps
	 */
	initMap() {
		var els = document.querySelectorAll('.c-map');
		for (let i = 0; i < els.length; i++) {
			//@TODO: loop through all elements marked for this module and apply the settings
			const data = this.getData(els[i]),
				centerLocation = {
					lat: data.lat,
					lng: data.lng
				},
				map = new google.maps.Map(els[i],
				{
					zoom: 16,
					center: centerLocation
				}
			);
		}
	}

	/**
	 * Load maps.googleapis library
	 */
	loadGMaps() {
		GMapsReady = true;
		//@TODO: only call the GoogleMapsAPI once. not for every instance
		loadGoogleMapsApi({
			apiKey: 'AIzaSyDW5VPkYx85y1RrM4aJvrQs0thsCDssVHg'
		})
			.then((googleApi) => {
				this.initMap();
			}, function (err) {
				GMapsReady = false;
			});
	}

	/**
	 * Initialize the module
	 */
	init() {
		if (!GMapsReady) {
			this.loadGMaps();
		}
	}
}

export { Maps as Maps };